import React from "react";
import { InputGroup, Form } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";

const SearchBar = ({ value, onChange, placeholder, inputClassName, inputStyle, inputProps }) => {
  return (
    <InputGroup className="flex-grow-1">
      <InputGroup.Text style={{ backgroundColor: "#fff", border: "none" }}>
        <FaSearch size={20} fill="#105587" />
      </InputGroup.Text>
      <Form.Control
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={inputClassName}
        style={inputStyle}
        {...inputProps}
      />
    </InputGroup>
  );
};

export default SearchBar;
